import React from "react";
import { Button, Input, Modal, ModalBody } from "reactstrap";
import { toast } from "react-toastify";

const BrandAmbassadorAgreement = ({
  isOpen,
  toggle,
  setAgreementBox,
  agreementBox,
  selectedClause,
  setSelectedClause,
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalBody>
        <div className="text-dark AggrementOuter">
          <h2 className="text-center text-dark">
            <u>BRAND AMBASSADOR AGREEMENT</u>
          </h2>

          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "center",
            }}
          >
            <strong>
              <span>&nbsp;</span>
            </strong>
          </p>
          <p className="text-dark text-justify m-0">
            This Brand Ambassador Agreement (“
            <b>Agreement</b>”) is made and entered as of _______________ (“
            <b>Effective Date</b>”), by and between FansHelpPlayers, LLC (“
            <b>FHP</b>”) and _____________________ (“<b>Athlete</b>”), each
            being referred to as individually as a “<b>Party</b>, and
            collectively as the “<b>Parties</b>” throughout this Agreement.
          </p>
          <p className="text-dark text-justify m-0">
            <span>&nbsp;</span>
          </p>
          <p
            className="text-dark text-justify m-0"
            style={{
              textIndent: "36pt",
            }}
          >
            <b>WHEREAS</b>, FHP operates an online platform (the “
            <b>Platform</b>”) that allows FHP to sell athlete-licensed Products
            and Services to fans including, but not limited to, Mementos,
            Badges, Videos, Endorsements, NIL-linked thank you associated with
            arrangements, as endorsed by athlete’s enrolled school, for
            legitimately needy athlete/his or her family a food assistance up to
            $100 total per any 6-month period (‘Pizza money”), and Online Chats
            between athletes and fans;
          </p>
          <p className="text-dark text-justify m-0">
            <span>&nbsp;</span>
          </p>
          <p
            className="text-dark text-justify m-0"
            style={{
              textIndent: "36pt",
            }}
          >
            <b>WHEREAS</b>, FHP wishes to engage Athlete for the purpose of
            Athlete preparing and presenting Products and Services at FHP, which
            Products and Services bear Athlete’s NIL rights; and
          </p>
          <p className="text-dark text-justify m-0">
            <span>&nbsp;</span>
          </p>
          <p
            className="text-dark text-justify m-0"
            style={{
              textIndent: "36pt",
            }}
          >
            <b>WHEREAS</b>, this Agreement sets forth certain terms and
            conditions pursuant to which Athlete may register a profile on the
            Platform (“Profile”) in order to engage in and/or provide the
            License of the NIL rights and the preparing and presenting of said
            Products and Services (as each are defined herein) for the Platform;
            and
          </p>
          <p className="text-dark text-justify m-0">
            <span>&nbsp;</span>
          </p>
          <p
            className="text-dark text-justify m-0"
            style={{
              textIndent: "36pt",
            }}
          >
            <b>WHEREAS</b>, this Agreement further sets forth certain terms and
            conditions pursuant to which FHP and Athlete will collaborate for
            the purpose of assisting FHP in said developing, preparing and/or
            presenting of Products and Services, including, but not limited to,
            hosted Online Chats, Videos, Badges, and Endorsements, each
            utilizing Athlete’s NIL Rights (as later defined), to be sold to
            third-party purchasers via the Platform in accordance with the terms
            set forth in this Agreement.
          </p>
          <p className="text-dark text-justify m-0">
            <span>&nbsp;</span>
          </p>
          <p
            className="text-dark text-justify m-0"
            style={{
              textIndent: "36pt",
            }}
          >
            <strong>NOW, THEREFORE</strong>, in consideration of the mutual
            promises and conditions contained in this Agreement, and for other
            good and valuable consideration, the receipt of which are hereby
            acknowledged, the Parties agree as follows:
          </p>
          <p className="text-dark text-justify m-0">
            <span>&nbsp;</span>
          </p>
          <h2 className="text-center text-dark">
            <u>TERMS AND CONDITIONS</u>
          </h2>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "center",
            }}
          >
            <strong>
              <span>&nbsp;</span>
            </strong>
          </p>
          <ol style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "14pt",
                textAlign: "justify",
                paddingLeft: "4pt",
              }}
            >
              <p className="text-dark">
                <strong>
                  <u>Term.</u>
                </strong>{" "}
                The term of this Agreement shall commence on the Effective Date
                and shall remain in full force and effect until the earlier of
                the following: (i) six (6) years following the Effective Date,
                or (ii) the date Athlete is no longer considered an amateur
                athlete and/or permanently elects to no longer participate in
                athletic competition at Athlete’s school (the <b>“Term”</b>).
                For the purpose of this Agreement, <b>“school”</b> shall mean
                Athlete’s high school/college/university and/or any other venue
                of amateur athletic competition pursuant to which Athlete is
                participant as an amateur athlete.
              </p>
            </li>
          </ol>
          <ol start={2} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "14pt",
                textAlign: "justify",
                paddingLeft: "4pt",
              }}
            >
              <p className="text-dark">
                <strong>
                  <u>Termination.</u>
                </strong>{" "}
                Either Party may elect to terminate this Agreement immediately
                upon written notice to the other Party as follows:
              </p>
            </li>
          </ol>
          <ol style={{ margin: "0pt", paddingLeft: "0pt" }} type="a">
            <li
              style={{
                marginLeft: "67.33pt",
                textAlign: "justify",
                paddingLeft: "4.67pt",
              }}
            >
              <p className="text-dark">
                <strong> Material Breach: </strong> A Party materially breaches
                any representation, warranty provision, duty, obligation, or
                covenant in this Agreement or refuses to fulfill any material
                obligation under this Agreement and such Party fails to cure
                such breach within thirty (30) days of receiving notice of such
                breach.
              </p>
            </li>
          </ol>
          <p
            className="text-dark"
            style={{
              marginLeft: "14pt",
              textAlign: "justify",
              paddingLeft: "4pt",
            }}
          >
            Additionally, FHP may terminate this Agreement, effective
            immediately upon written notice to Athlete and without penalty or
            further obligation, for any of the following:
          </p>
          <ol start={2} style={{ margin: "0pt", paddingLeft: "0pt" }} type="a">
            <li
              style={{
                marginLeft: "68pt",
                textAlign: "justify",
                paddingLeft: "4pt",
              }}
            >
              <p className="text-dark">
                <strong> TOS Violation:</strong> FHP may terminate this
                Agreement in the event Athlete violates any provision contained
                within the Platform’s Terms and Conditions.
              </p>
            </li>
          </ol>
          <ol start={3} style={{ margin: "0pt", paddingLeft: "0pt" }} type="a">
            <li
              style={{
                marginLeft: "67.33pt",
                textAlign: "justify",
                paddingLeft: "4.67pt",
              }}
            >
              <p className="text-dark">
                <strong>High School/NCAA Rules or Laws Violation:</strong> FHP
                may terminate this Agreement in the event that: (i) FHP, in its
                sole and absolute discretion, determines or becomes aware that
                (a) the existence of this Agreement, entering into this
                Agreement, and/or performance of this Agreement in any way
                violates, contradicts or is otherwise affected by high school
                district rules and regulations, NCAA rules and/or other
                applicable university policy or rules governing use of Athlete’s
                NIL Rights (collectively, <b>“NIL Policy”</b>), and/or
                applicable laws (whether federal, state, or otherwise) (the{" "}
                <b>“Laws”</b>), and/or (b) any requirements, limitations or
                provisions contained in any NIL Policy and/or Laws, or the
                actual or potential enforcement thereof, renders performance of
                this Agreement impossible or impracticable and/or presents a
                legal or reputational risk to FHP.
              </p>
            </li>
          </ol>
          <p
            className="text-dark"
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              textAlign: "justify",
            }}
          >
            Upon the expiration or termination of this Agreement, all rights
            granted hereunder shall automatically terminate; provided, following
            the expiration or termination of this Agreement in accordance with
            Section 2(a) or Section 2(b), FHP shall have the continued right, in
            perpetuity, to sell the products produced at FHP to the date of said
            expiration or termination and bearing Athlete’s NIL Rights in
            accordance with the terms set forth in this Agreement.
          </p>
          <ol start={3} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "14pt",
                textAlign: "justify",
                paddingLeft: "4pt",
              }}
            >
              <p className="text-dark">
                <strong>
                  <u>License; Non-Exclusivity.</u>
                </strong>
              </p>
            </li>
          </ol>
          <ol style={{ margin: "0pt", paddingLeft: "0pt" }} type="a">
            <li
              style={{
                marginLeft: "67.33pt",
                textAlign: "justify",
                paddingLeft: "4.67pt",
              }}
            >
              <p className="text-dark">
                During the Term, Athlete grants FHP the <b>non-exclusive,</b>{" "}
                worldwide, royalty-free (except as otherwise set forth herein),
                sublicensable right and license to use Athlete’s name, image,
                likeness, biographical details, logos, videos, and all other
                indicia of identity specified and/or associated with Athlete{" "}
                <b>(“Athlete’s NIL Rights”)</b>, solely in connection with: (i)
                promoting FHP and/or the Platform, and (ii) in furtherance of
                preparing, presenting, distributing, marketing, advertising, and
                selling Products and Services on the Platform (the{" "}
                <b>“License”</b>). Athlete agrees that FHP will have the right
                to grant sublicenses and take further acts with respect to the
                License consistent with the enjoyment of its grant of the
                License herein. Except as may arise from a breach of this
                Agreement, Athlete hereby irrevocably waives and agrees not to
                assert any claims based on moral rights or any other theory
                based on FHP’s exercise of the License. All materials submitted
                by Athlete bearing Athlete’s NIL Rights{" "}
                <b>(“Athlete Materials”)</b> shall be deemed approved for use in
                accordance with the terms set forth in this Agreement.
              </p>
            </li>
          </ol>
          <ol start={2} style={{ margin: "0pt", paddingLeft: "0pt" }} type="a">
            <li
              style={{
                marginLeft: "67.33pt",
                textAlign: "justify",
                paddingLeft: "4.67pt",
              }}
            >
              <p className="text-dark">
                Notwithstanding, Athlete reserves all rights in and to Athlete’s
                NIL Rights to the extent not granted herein.
              </p>
            </li>
          </ol>
          <ol start={4} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "14pt",
                textAlign: "justify",
                paddingLeft: "4pt",
              }}
            >
              <p>
                <strong>
                  <u>Services.</u>
                </strong>{" "}
                During the Term, Athlete agrees to provide the services set
                forth in{" "}
                <b>
                  <u>Schedule A</u>
                </b>
                , attached hereto.
              </p>
            </li>
          </ol>
          <ol start={5} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "14pt",
                textAlign: "justify",
                paddingLeft: "4pt",
              }}
            >
              <p className="text-dark">
                <strong>
                  <u>Compensation.</u>
                </strong>{" "}
                In exchange for the License and Athlete’s performance of
                Services under this Agreement, FHP agrees to compensate Athlete
                in accordance with the terms set forth in{" "}
                <b>
                  <u>Schedule B</u>
                </b>
                , attached hereto (“
                <b>Compensation</b>”).
              </p>
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            &nbsp;
          </p>
          <ol start={6} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "14pt",
                textAlign: "justify",
                paddingLeft: "4pt",
              }}
            >
              <strong>
                <u> Athlete Profile Requirements.</u>
              </strong>{" "}
              In order to provide the Services, Athlete must create a Profile on
              the Platform. By creating a Profile on the Platform, Athlete
              agrees to provide true, accurate, current, and complete
              information, and comply with the Terms and Conditions provided via
              the Platform. Athlete agrees not to create a Profile using a false
              identity or providing false information or if Athlete has
              previously been removed or banned from the Platform. Athlete is
              responsible for maintaining the confidentiality of Athlete’s
              Profile information, including Athlete’s username and password.
              Athlete is responsible for all activities that occur on or in
              connection with Athlete’s Profile. Athlete agrees to immediately
              notify FHP of any unauthorized access or use of Athlete’s Profile.
              Athlete acknowledges and agrees that FHP is not responsible or
              liable for any damages, losses, costs, expenses, or liabilities
              related to any unauthorized access to or use of Athlete’s Profile.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "36pt",
              marginBottom: "0pt",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <ol start={7} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "14pt",
                textAlign: "justify",
                paddingLeft: "4pt",
              }}
            >
              <strong>
                <u>Profile Verification.</u>
              </strong>{" "}
              FHP reserves the right to verify Athlete’s Profile information
              (including, but not limited to, contacting Athlete and/or
              Athlete’s school) in order to ensure Athlete’s eligibility to
              participate on the Platform. In the event FHP determines that a
              Profile is not eligible for participation on the Platform, FHP
              reserves the right to immediately remove the Profile without prior
              warning or written notice.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "36pt",
              marginBottom: "0pt",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <ol start={8} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "14pt",
                textAlign: "justify",
                paddingLeft: "4pt",
              }}
            >
              <strong>
                <u>Disclosure.</u>
              </strong>{" "}
              Athlete understands that it is Athlete’s sole responsibility to
              notify and/or report this Agreement (including, but not limited
              to, deal terms and compensation) as needed to Athlete’s school,
              conference, and/or any other governing entity responsible for
              determining athlete’s eligibility. FHP acknowledges and agrees
              that this Agreement is subject to the approval of Athlete’s
              university (or other academic institution or regulatory body) as
              is, or may be, required by applicable law. Accordingly, Athlete
              acknowledges and agrees that this Agreement will be available for
              disclosure to Athlete’s school/university/regulatory body prior to
              and after the execution hereof.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            &nbsp;
          </p>
          <ol start={9} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "14pt",
                textAlign: "justify",
                paddingLeft: "4pt",
              }}
            >
              <strong>
                <u>
                  Producing Videos, Badges, Endorsements, Online Chats, Mementos
                  and/or other Products and Services.{" "}
                </u>
              </strong>{" "}
              By completing registration and creating a Profile on the Platform,
              Athlete agrees and acknowledges each of the following:
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <ol style={{ margin: "0pt", paddingLeft: "0pt" }} type="a">
            <li
              style={{
                marginLeft: "67.33pt",
                textAlign: "justify",
                paddingLeft: "4.67pt",
              }}
            >
              Athlete authorizes and grants FHP an irrevocable license to use
              Athlete’s NIL Rights to create, store, distribute, and sell
              electronic and physical Products and Services with Athlete’s name,
              image, and/or likeness, the amount thereof to be mutually
              determined by FHP and Athlete; and
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "72pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <ol start={2} style={{ margin: "0pt", paddingLeft: "0pt" }} type="a">
            <li
              style={{
                marginLeft: "68pt",
                textAlign: "justify",
                paddingLeft: "4pt",
              }}
            >
              Athlete and FHP shall mutually cooperate to provide hosted chats
              online, the frequency, schedule, and content to be mutually
              determined by FHP and Athlete; and
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "72pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <ol start={2} style={{ margin: "0pt", paddingLeft: "0pt" }} type="a">
            <li
              style={{
                marginLeft: "68pt",
                textAlign: "justify",
                paddingLeft: "4pt",
              }}
            >
              Athlete and FHP shall mutually cooperate to determine the purchase
              price of Products and Services created utilizing Athlete’s NIL
              Rights
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "36pt",
              marginBottom: "0pt",
            }}
          >
            <strong>
              <span>&nbsp;</span>
            </strong>
          </p>
          <ol start={10} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>FTC Guidelines.</u>
              </strong>{" "}
              Athlete shall comply with all applicable laws, rules, and
              regulations, including the Federal Trade Commission’s “Guides
              Concerning the Use of Endorsements and Testimonials in
              Advertising”, as amended, with regard to Athlete’s promotion
              and/or endorsement of FHP and/or the Platform.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "36pt",
              marginBottom: "0pt",
            }}
          >
            <strong>
              <span>&nbsp;</span>
            </strong>
          </p>
          <ol start={11} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Platform Ownership.</u>
              </strong>{" "}
              Except as it relates to Athlete Materials and/or other content
              provided by Athlete in accordance with Athlete’s participation on
              the Platform, FHP shall own all right, title, and interest in and
              to: (i) the Platform, including all software, ideas, processes,
              data, text, media, and other content available on the Platform
              (individually, and collectively, <b>“Platform Content”</b>); and
              (ii) FHP’s trademarks, logos, and brand (<b>“Marks”</b>). Athlete
              shall not duplicate, copy, or reuse any portion of Platform
              Content or use the Marks without FHP’s prior express written
              consent.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "36pt",
              marginBottom: "0pt",
            }}
          >
            <strong>
              <span>&nbsp;</span>
            </strong>
          </p>
          <ol start={12} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Work for Hire.</u>
              </strong>{" "}
              Athlete agrees and acknowledges that all Products shall be created
              as original files owned by FHP, and Athlete acknowledges that all
              Products and Services and/or materials (including, but not limited
              to, Athlete Materials) provided by Athlete’s preparing and
              presenting for and on behalf of FHP under this Agreement shall
              constitute “works made for hire” as defined by United States
              Copyright Law (17 U.S.C. § 101, et seq.) and that all rights,
              title, and interest in and to all materials, ideas, feedback,
              suggestions, improvements, themes, creations, documents, designs,
              concepts, deliverables, and/or copyrights (but expressly excluding
              Athlete’s NIL Rights) (collectively, the <b>“Works”</b>) shall
              solely and exclusively be owned by FHP in perpetuity and
              throughout the world. In furtherance thereof Athlete shall not
              have, nor lay claim to any rights, title, or interest in and to
              any Works provided hereunder. All ownership rights, title, and
              interest in and to the Works, and any and all derivative works
              made therefrom, will be, become, and remain the sole property of
              FHP during and after the Term. If, for any reason, the Works are
              determined not to be "works made for hire" or such doctrine is not
              effective, then Athlete hereby irrevocably assigns, conveys, and
              otherwise transfers to FHP, and its respective successors,
              licensees, and assigns, in perpetuity, all right, title and
              interest worldwide in and to the Works, and all proprietary rights
              therein, in any and all media now known or hereafter developed,
              including all copyrights, trademarks, design patents, trade secret
              rights, moral rights, and all contract and licensing rights, and
              all ancillary, subsidiary and derivative rights contained therein
              and all elements thereof, and the exclusive right to advertise,
              publicize, market, distribute and/ or sell product developed in
              connection with the Works and anything contained therein, on the
              Platform and/or any other medium.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <strong>
              <span>&nbsp;</span>
            </strong>
          </p>
          <ol start={13} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Platform Feedback.</u>
              </strong>{" "}
              To the extent Athlete submits any ideas, suggestions, proposals,
              plans, or other materials related to the Platform (individually,
              and collectively, “Feedback”), Athlete acknowledges and agrees
              that Athlete is submitting Feedback at Athlete’s own risk and that
              FHP has no obligation (including of confidentiality or privacy)
              with respect to Athlete’s Feedback. Athlete grants FHP a
              non-exclusive, royalty-free, fully paid, unlimited, universal,
              sublicensable (through multiple tiers of sublicenses), perpetual,
              and irrevocable license, in any and all manner and media, whether
              now known or hereinafter invented or devised, to reproduce,
              license, distribute, modify, adapt, publicly perform, publicly
              display, create derivative works of (for example, translations,
              adaptations, or other changes), and otherwise use and exploit in
              any manner (including commercially), any and all Feedback.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "36pt",
              marginBottom: "0pt",
            }}
          >
            <strong>
              <span>&nbsp;</span>
            </strong>
          </p>
          <ol start={14} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Non-Disparagement.</u>
              </strong>{" "}
              Athlete agrees that at no time during and after the Term will
              Athlete disparage FHP or the Platform.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <strong>
              <span>&nbsp;</span>
            </strong>
          </p>
          <ol start={15} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Confidentiality.</u>
              </strong>{" "}
              The Parties acknowledge and agree that the terms of this
              Agreement, and any and all confidential information regarding a
              Party or its operations that is disclosed by a Party to the other
              in furtherance of this Agreement, including, without limitation,
              information concerning the Parties’ operating and marketing
              methods, pricing practices, sales figures, and/or any other
              information deemed proprietary by the disclosing Party (
              <b>“Confidential Information”</b>) will be treated as confidential
              and will not be disclosed to any third party (except as set forth
              herein) at any time during the Term of this Agreement and
              thereafter or used for any purposes other than for purposes
              contemplated by this Agreement.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>
              Each Party agrees to: (i) protect the other Party’s Confidential
              Information using the same standard of care it uses to protect its
              own Confidential Information, provided that in no event will a
              Party use less than a reasonable standard of care; and (ii) not
              disclose the other Party’s Confidential Information, except to its
              affiliates, contractors, employees, independent contractors, and
              agents who express a “need to know” and have agreed in writing or
              are otherwise under a legal duty to keep such information
              confidential at a level no less protective than required herein.
              Each Party (and any affiliates, contractors, employees and agents
              to whom it has disclosed Confidential Information) may use the
              other Party’s Confidential Information only to the extent
              necessary to exercise the rights granted and fulfill its duties
              and obligations contained within this Agreement, and each Party
              acknowledges that it shall be responsible for the actions of any
              of its affiliates, partners, contractors, employees, and agents
              that are in violation hereof. All Confidential Information shall
              be the exclusive property of the disclosing Party and shall be
              returned to the disclosing Party, or destroyed, immediately upon
              the termination or expiration of this Agreement, or at any other
              time at the disclosing Party’s request.
            </span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>
              Each Party may disclose the other Party’s Confidential Information
              when required by law but only to the extent necessary to comply
              with such law and only after such Party, if legally permissible:
              (i) uses commercially reasonable efforts to notify the other
              Party; and (ii) gives the other Party the chance to challenge or
              limit the disclosure.
            </span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "36pt",
              marginBottom: "0pt",
            }}
          >
            <strong>
              <span>&nbsp;</span>
            </strong>
          </p>
          <ol start={16} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Representations and Warranties.</u>
              </strong>{" "}
              Each Party represents, warrants, and covenants to the other Party
              that it has the full right and power to (i) enter into this
              Agreement, (ii) perform all obligations to be performed by it
              hereunder, and (iii) grant all rights hereunder granted, in each
              case without violating the legal or equitable rights of any other
              person or entity.
            </li>
          </ol>

          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <strong>&nbsp;</strong>
          </p>

          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>
              Athlete further represents and warrants that, as of the Effective
              Date and continuing throughout the Term of this Agreement, the
              Athlete Materials, and FHP’s and/or its affiliates' exercise of
              any License granted under this Agreement, does not and will not:
              (i) infringe the rights of any third party; or (ii) require the
              payment by FHP of any royalties, remuneration, residuals or any
              other fees (except as otherwise set forth herein); or (iii) result
              in any tort, injury, damage or harm to any third party.
            </span>
          </p>

          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <strong>&nbsp;</strong>
          </p>

          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>
              Athlete further represents and warrants that, as of the Effective
              Date and continuing throughout the Term of this Agreement, no use
              by Athlete of any function of the FHP platform will occur without{" "}
              <b>
                Athlete first verifying with his or her advisor that the
                function or functions which Athlete contemplates to use at FHP
                is/are a use without risk to his or her amateur status
              </b>{" "}
              under applicable NIL laws, guidelines, and/or policies of
              Athlete’s school or relevant regulatory body.{" "}
              <b>Athlete is solely responsible for said pre-verification.</b>
            </span>
          </p>

          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <strong>&nbsp;</strong>
          </p>

          <ol start={17} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Indemnification.</u>
              </strong>{" "}
              Athlete shall defend, indemnify and hold harmless FHP, and FHP’s
              officers, directors, employees, representatives, and members,
              (collectively, <b>“FHP Indemnitees”</b>), from and against any and
              all claims, suits, losses, damages and expenses (including
              reasonable attorney’s fees and expenses), resulting from third
              party claims made or suits brought against any FHP Indemnitee to
              the extent based on any action or omissions by or on behalf of
              Athlete, including, without limitation, those based upon: (i)
              Athlete’s grant of the License; (ii) FHP’s use of the Athlete
              Materials and/or Athlete’s NIL Rights in accordance with the terms
              set forth in this Agreement; (iii) any negligent act, error or
              omission, or willful misconduct of Athlete, or any third party
              acting for or on behalf of Athlete; and/or (iv) Athlete’s breach
              of any term, condition, representation, or warranty contained in
              this Agreement (each a “Claim”). If any Claim is brought against
              an FHP Indemnitee, Athlete will defend such Claim at Athlete’s
              sole expense using counsel selected by the FHP Indemnitee. If
              Athlete fails to take timely action to defend such Claim, the FHP
              Indemnitee may defend such Claim at Athlete’s expense, including,
              without limitation, deduction of any Compensation payable under
              this Agreement. Athlete shall cooperate in all reasonable respects
              with the investigation, disclosure and defense of any Claim.
              Athlete will not settle, compromise or otherwise enter into any
              agreement regarding the disposition of any Claim against an FHP
              Indemnitee without the prior written consent and approval of the
              FHP Indemnitee.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <strong>
              <span>&nbsp;</span>
            </strong>
          </p>
          <ol start={18} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Limitation of Liability.</u>
              </strong>{" "}
              Notwithstanding Athlete’s duty to indemnify FHP in accordance with
              Section 17 of this Agreement, in no event shall either Party be
              liable to the other Party for any special, exemplary, indirect,
              incidental, consequential, or punitive damages of any kind or
              nature whatsoever (including, without limitation, lost revenue,
              profits, savings, or business), whether in an action based on
              contract, warranty, strict liability, tort (including, without
              limitation, negligence) or otherwise, even if such Party has been
              informed in advance of the possibility of such damages, or if such
              damages could have reasonably been foreseen by such Party. In no
              event will FHP’s liability under this Agreement exceed the total
              amount of Compensation paid by FHP to Athlete in the six (6)
              months preceding the act that gave rise to liability.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <strong>
              <span>&nbsp;</span>
            </strong>
          </p>
          <ol start={19} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Waiver.</u>
              </strong>{" "}
              The failure of either Party to exercise the rights granted to such
              Party under this Agreement upon the occurrence of any of the
              contingencies set forth in this Agreement shall not in any event
              constitute a waiver of any such rights upon the occurrence of any
              additional such contingencies.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <ol start={20} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Notices.</u>
              </strong>{" "}
              Any notice required to be given hereunder shall be given by
              sending the same by email, overnight express mail or registered or
              certified mail, postage prepaid, return receipt requested to the
              address stated herein, or to any subsequent address designated by
              either Party for the purpose of receiving notices pursuant to this
              Agreement. All notices shall be deemed validly given: (i) after
              one (1) business day if sent via email or overnight express mail,
              or (ii) after five (5) business days if sent via registered or
              certified mail. Notices shall be sent to the following:
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span> to FHP:</span>
            <span
              style={{
                width: "5.33pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                width: "36pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                width: "36pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span>128 DORCHESTER F</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span
              style={{
                width: "18pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                width: "36pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                width: "36pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                width: "28pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span>WEST PALM BEACH, FL 33417</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
            <span>Email: fanshelpplayers@gmail.com</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "126pt",
              marginBottom: "0pt",
              textIndent: "18pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>If to Athlete:&nbsp;</span>
            <span
              style={{
                width: "25.02pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                width: "36pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span>______________________</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span
              style={{
                width: "18pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                width: "36pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                width: "36pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                width: "36pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span>______________________</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span
              style={{
                width: "18pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                width: "36pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                width: "36pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                width: "36pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span>Email: ________________</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <ol start={21} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Press Release; Promotion.</u>
              </strong>{" "}
              The Parties may, upon mutual agreement, issue a press release upon
              execution of this Agreement or issue other public marketing and
              communications materials during the Term detailing and/or
              promoting the Platform, and/or Products or Services bearing
              Athlete’s NIL Rights. FHP and Athlete agree to work together in
              good faith to undertake mutually agreed upon advertising and
              promotional activities for the promotion of the Platform,
              including, but not limited to, Athlete promoting the Platform,
              FHP, FHP’s release of Badges, Videos, Mementos, Endorsements,
              Online Chats, and the relationship provided for herein on
              Athlete’s official social media and/or streaming platforms
              (including, but not limited to, Twitter, Instagram, Twitch,
              YouTube, and/or Facebook).
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <ol start={22} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Severability.</u>
              </strong>{" "}
              In the event any provision of this Agreement is determined to be
              invalid by a court of competent jurisdiction, such determination
              shall in no way affect the validity or enforceability of any other
              provision contained herein.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "36pt",
              marginBottom: "0pt",
            }}
          >
            &nbsp;
          </p>
          <ol start={23} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Equitable Relief.</u>
              </strong>{" "}
              Athlete acknowledges that the License and Athlete’s preparation
              and presenting of Products and/or Services provided pursuant to
              this Agreement are personal and unique, and a breach of this
              Agreement would cause FHP irreparable injury for which there is no
              adequate remedy at law. In the event of Athlete’s breach (or
              threatened breach) of any terms, representations, or warranties
              contained within this Agreement, FHP will have the right to
              enforce this Agreement and any of its provisions by injunction,
              specific performance, or other equitable relief without prejudice
              to any other legal or equitable relief to which it may have for
              Athlete’s breach (or threatened breach) of this Agreement, and
              without any obligation to post a bond or other security or to
              prove damages.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <ol start={24} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Governing Law; Dispute Resolution.</u>
              </strong>{" "}
              This Agreement shall be governed by and construed in accordance
              with the laws of the State of Florida, without regard to conflict
              of law principles thereof. Each Party agrees that binding
              arbitration under the Commercial Rules of Arbitration of the
              American Arbitration Association before a single arbitrator shall
              resolve any dispute or controversy arising in connection with this
              Agreement. Judgment upon any award may be entered in any court of
              competent jurisdiction. The decision of the arbitrator shall be
              binding and conclusive upon the Parties. In the event of any legal
              action or arbitration proceeding brought for the enforcement of
              this Agreement, the prevailing party shall be entitled to recover
              reasonably incurred attorney’s fees and costs. Notwithstanding,
              this agreement to binding arbitration shall not prevent either
              Party from seeking injunctive and/or other equitable relief from a
              court of competent jurisdiction.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <ol start={25} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Relationship of the Parties.</u>
              </strong>{" "}
              The Parties agree that nothing herein shall be deemed to
              constitute either Party as a partner, employee, joint venture, or
              agent of the other Party. Neither Party shall have the power or
              authority to bind the other with respect to third parties or to
              represent to third parties that they have such authority. Athlete
              expressly acknowledges and agrees that FHP will not withhold any
              federal, state or local income or unemployment insurance or social
              security taxes from any payments made under this Agreement (except
              where tax withholding is otherwise required by law), and that it
              is the responsibility of Athlete to report and pay all income,
              unemployment insurance, social security and other taxes on
              Athlete’s own behalf.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <ol start={26} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u> No Third-Party Beneficiaries. </u>
              </strong>{" "}
              Nothing contained herein, expressed or implied, is intended or
              shall be construed to confer upon or give to any person or entity,
              other than the Parties to this Agreement and their respective
              successors and permitted assigns, any rights or remedies under or
              by reason of this Agreement. This Agreement, and all provisions
              and conditions hereof, are intended to be, and shall be, for the
              sole and exclusive benefit of the Parties and their respective
              successors and permitted assigns, and not for the benefit of any
              other person or entity.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "36pt",
              marginBottom: "0pt",
            }}
          >
            &nbsp;
          </p>
          <ol start={27} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Force Majeure.</u>
              </strong>{" "}
              In the event that either Party’s performance of any of its
              respective duties and obligations under this Agreement is
              prevented or hindered due to any act of God, fires, strikes, labor
              disputes, accidents, embargoes, riots, floods, earthquakes, wars,
              pandemic, epidemic, governmental actions, or other circumstances
              beyond the control of such Party (each, a{" "}
              <b>“Force Majeure Event”</b>), then such performance shall wholly
              or partially be suspended during the period in which the Force
              Majeure Event is in existence, and no Party shall be liable to the
              other Party during such period owing to such circumstances.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <ol start={28} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Assignment.</u>
              </strong>{" "}
              This Agreement and any rights or obligations of Athlete hereunder
              shall not be assigned or delegated, whether by transfer, merger,
              operation of law or otherwise, without FHP’s prior written
              consent. FHP may assign and/or sublicense its rights hereunder to
              any affiliate or successor entity in the event of a merger,
              reorganization or sale of FHP, or substantially all of its assets.
              All provisions of this Agreement are binding upon, shall inure to
              the benefit of, and are enforceable by or against the Parties and
              their respective heirs, executors, administrators or other legal
              representatives and permitted successors and assigns.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <ol start={29} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Entire Agreement.</u>
              </strong>{" "}
              This Agreement and schedules attached hereto constitute the entire
              understanding between the Parties with respect to the subject
              matter of this Agreement and supersedes all prior agreements
              whether written or oral. No waiver, modification or addition to
              this Agreement shall be valid unless made in writing and signed by
              the Parties hereto. This Agreement may be executed concurrently in
              one or more counterparts, each of which shall be an original, but
              all of which together shall constitute one and the same
              instrument. This Agreement shall not be binding upon either Party
              until executed by an authorized officer thereof.
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <ol start={30} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "18pt",
                textAlign: "justify",
              }}
            >
              <strong>
                <u>Platform Terms and Conditions</u>
              </strong>{" "}
              Athlete agrees that Athlete’s participation on the Platform shall
              remain subject to the provisions set forth in Platform’s Terms and
              Conditions; provided, in the event of any conflict between this
              Agreement and the Platform’s Terms and Conditions, the terms set
              forth in this Agreement shall prevail.
            </li>
          </ol>
          <span>&nbsp;</span>
          <div style={{ border: "3px solid #f5365c", borderRadius: "8px", padding: "15px", backgroundColor: "#fff5f6", margin: "20px 0" }}>
            <h4 style={{ color: "#f5365c", fontWeight: "bold", textTransform: "uppercase", marginBottom: "10px" }}>
              ⚠️ ATTENTION REQUIRED: PART 31 OF THE CONTRACT
            </h4>
            <ol start={31} style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
              <li style={{ marginLeft: "18pt", textAlign: "justify", fontWeight: "bold" }}>
                <u>Selects as a binding clause of this contract</u>
              </li>
              <div style={{ marginLeft: "36pt", marginTop: "10px" }}>
                <label style={{ display: "flex", alignItems: "flex-start", marginBottom: "10px", cursor: "pointer" }}>
                  <span style={{ color: "red", fontWeight: "900", marginRight: "8px", fontSize: "36px", lineHeight: "16px", textShadow: "0 0 1px red, 0 0 1px red", marginTop: "0px" }}>→</span>
                  <input
                    type="checkbox"
                    name="contractClause"
                    value="not_permitted"
                    checked={selectedClause === "not_permitted"}
                    onChange={() => setSelectedClause("not_permitted")}
                    style={{ marginRight: "8px", flexShrink: 0, marginTop: "5px", transform: "scale(1.2)" }}
                  />
                  <span>
                    Parties to this contract agree that Athlete is{" "}
                    <strong>NOT</strong> permitted to share the details of this
                    contract with outside parties.
                  </span>
                </label>
                <label style={{ display: "flex", alignItems: "flex-start", marginBottom: "10px", cursor: "pointer" }}>
                  <span style={{ color: "red", fontWeight: "900", marginRight: "8px", fontSize: "36px", lineHeight: "16px", textShadow: "0 0 1px red, 0 0 1px red", marginTop: "0px" }}>→</span>
                  <input
                    type="checkbox"
                    name="contractClause"
                    value="permitted"
                    checked={selectedClause === "permitted"}
                    onChange={() => setSelectedClause("permitted")}
                    style={{ marginRight: "8px", flexShrink: 0, marginTop: "5px", transform: "scale(1.2)" }}
                  />
                  <span>
                    Parties to this contract agree that Athlete is{" "}
                    <strong>free</strong> to share the details of this contract.
                  </span>
                </label>
              </div>
            </ol>
          </div>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <strong>
              <span>&nbsp;</span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textIndent: "18pt",
              textAlign: "justify",
            }}
          >
            <strong>
              <span>IN WITNESS WHEREOF</span>
            </strong>
            <span>
              , the Parties have duly executed this Agreement as of the
              Effective Date written above, wherein execution for Athlete is
              made effective through Athlete’s registration of Athlete’s Profile
              on the FHP website via Athlete’s “Click to Accept” of these terms.
            </span>
          </p>
          <p
            style={{
              marginTop: "3px",
              marginBottom: "0pt",
              textIndent: "18pt",
              textAlign: "center",
            }}
          >
            <strong>
              <span>Handshake Agreement</span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textIndent: "18pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textIndent: "18pt",
              textAlign: "justify",
            }}
          >
            <strong>
              <span>ATHLETE</span>
            </strong>
            <span
              style={{
                width: "13.98pt",
                textIndent: "0pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span style={{ color: "red", fontWeight: "900", marginRight: "8px", fontSize: "36px", textShadow: "0 0 1px red, 0 0 1px red", lineHeight: "16px", display: "inline-block" }}>→</span>
            <input
              required
              type="checkbox"
              checked={agreementBox}
              onChange={(e) => setAgreementBox(e.target.checked)}
            />
            <strong>
              <span> I ACCEPT</span>
            </strong>
            <span
              style={{
                width: "2.33pt",
                textIndent: "0pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                width: "36pt",
                textIndent: "0pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <strong>
              <span>FANSHELPPLAYERS, LLC</span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
                    <p style={{ margin: "0pt", paddingLeft: "0pt", fontWeight: "700" }}>
 Signatures not required. Click Next to agreement pop up to return to continue registration
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>By: ______________________________</span>
            <span
              style={{
                width: "15.66pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span
              style={{
                width: "21pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span>By: ________________________________</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>Name: ________________________</span>
            <span
              style={{
                width: "1.01pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span>___</span>
            <span
              style={{
                width: "18pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                width: "36pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span>Name: ________________________</span>
            <span
              style={{
                width: "1.01pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span>______</span>
          </p>

          <p
            style={{
              marginTop: "20px",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>Name: ________________________</span>
            <span
              style={{
                width: "1.01pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span>___</span>
            <span
              style={{
                width: "18pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <span
              style={{
                width: "36pt",
                display: "inline-block",
              }}
            >
              &nbsp;
            </span>
            <em>
              <span>I have authority to bind FHP</span>
            </em>
          </p>

          {/* <a
            target="_blank"
            download="aggrement File"
            href="https://firebasestorage.googleapis.com/v0/b/fans-help-players.appspot.com/o/NEW_BRAND_AMBASSADOR_CONTRACT%20.docx?alt=media&token=9c580f89-c86a-47e1-9560-6575da8ef0ec&_gl=1*e67eb2*_ga*MTU4MTIzMTk5NS4xNjgzNzkwODU2*_ga_CW55HF8NVT*MTY5NjI0MjUwNy40ODAuMS4xNjk2MjQyNjYyLjU1LjAuMA.."
          >
            <Button className="bg-primary text-white border-0 ml-2 ml-lg-5">
              Download
            </Button>
          </a> */}

          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "center",
            }}
          >
            <strong>
              <span>&nbsp;</span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0pt",
              textAlign: "center",
            }}
          >
            <strong>
              <span>SCHEDULE A</span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "center",
            }}
          >
            <strong>
              <u>
                <span>Services</span>
              </u>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <ol style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "14pt",
                textAlign: "justify",
                paddingLeft: "4pt",
              }}
            >
              <strong>
                <u>Athlete Duties and Obligations .</u>
              </strong>
              During the Term, Athlete shall perform each of the following
              services, as required and/or directed by FHP (the “<b>Services</b>
              ”):
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <ul style={{ margin: "0pt", paddingLeft: "0pt" }} type="disc">
            <li
              style={{
                marginLeft: "46.52pt",
                textAlign: "justify",
                paddingLeft: "7.48pt",
              }}
            >
              <span>
                Athlete shall serve as brand ambassador for the Platform{" "}
                <b>
                  (where allowed by relevant NIL law. NIL regulation, and school
                  policy and only in circumstances not posing risk to Athlete’s
                  amateur status as per advice of Athlete’s advisor),
                </b>{" "}
                including, but not limited to, preparing and presenting FHP
                Products to include Videos, Badges, Endorsements, and Mementos,
                and participating in FHP Services to include Online Chats via
                Zoom or similar platform for the purpose of, among other things,
                teaching fans about general sports topics and/or the Platform.
                and teaching Department of Athletics staff about the electronic
                template functions of the platform.
              </span>
            </li>
          </ul>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "54pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <ul style={{ margin: "0pt", paddingLeft: "0pt" }} type="disc">
            <li
              style={{
                marginLeft: "46.52pt",
                textAlign: "justify",
                paddingLeft: "7.48pt",
              }}
            >
              <span>
                Athlete shall promote FHP and/or the Platform on Athlete’s
                social media, as minimum of eight (8) posts per year (the{" "}
                <b>’Social Media’</b> Posts). FHP may inform Athlete of
                suggestions as to when to publish such Social Media Posts.
                Social Media Posts may tag and/or mention FHP and/or the
                Platform through authorized hash tags or Ads as provided and as
                requested by FHP. Athlete shall provide to FHP upon request,
                proof of said posts such as in form of screenshots.
              </span>
            </li>
          </ul>

          <p
            style={{
              marginTop: "0pt",
              marginLeft: "36pt",
              marginBottom: "0pt",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "center",
            }}
          >
            <strong>
              <span>SCHEDULE B</span>
            </strong>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "center",
            }}
          >
            <strong>
              <span>&nbsp;</span>
            </strong>
          </p>
          <p className="text-center">
            <strong>
              <u>
                <span>Compensation</span>
              </u>
            </strong>
          </p>
          <ol style={{ margin: "0pt", paddingLeft: "0pt" }} type={1}>
            <li
              style={{
                marginLeft: "14pt",
                textAlign: "justify",
                paddingLeft: "4pt",
              }}
            >
              <strong>
                <u>Royalties.</u>
              </strong>{" "}
              Regarding FHP’s sale of Products and Services bearing Athlete’s
              NIL rights, FHP agrees to pay Athlete a percentage of Gross
              Revenue (or other benefits as defined below) earned /derived
              therefrom as follows:
            </li>
          </ol>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <table
            cellPadding={0}
            cellSpacing={0}
            style={{
              marginLeft: "18pt",
              border: "0.75pt solid #000000",
              borderCollapse: "collapse",
            }}
            width="96%"
          >
            <tbody>
              <tr style={{ height: "36.4pt" }}>
                <td
                  style={{
                    width: "267.95pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "0.75pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "12pt",
                    }}
                  >
                    <strong>
                      <span>
                        Sales of Mementos bearing Athlete’s NIL Rights
                      </span>
                    </strong>
                  </p>
                </td>
                <td
                  style={{
                    width: "159.95pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "0.75pt",
                    borderBottomStyle: "solid",
                    borderBottomWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "12pt",
                    }}
                  >
                    <span>
                      88% - Athlete (if no School IP or Manager used) &nbsp;
                    </span>
                  </p>
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "12pt",
                    }}
                  >
                    <span>
                      78% - Athlete (if School IP used but no Manager used)
                    </span>
                  </p>
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "12pt",
                    }}
                  >
                    <span>
                      78% - Athlete (if Manager used but no School IP used)
                    </span>
                  </p>
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "12pt",
                    }}
                  >
                    <span>
                      68% - Athlete (if School IP used and Manager used)
                    </span>
                  </p>
                </td>
              </tr>
              <tr style={{ height: "36.4pt" }}>
                <td
                  style={{
                    width: "267.95pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "0.75pt",
                    borderRightStyle: "solid",
                    borderRightWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "12pt",
                    }}
                  >
                    <strong>
                      <span>
                        Food Assistance (‘Pizza Money’) for eligible athletes
                      </span>
                    </strong>
                    <br />
                    <br />
                    <strong>
                      <span>
                        Sales of Endorsements, Seasonal Badges/Videos, Talking
                        Badges, Sport Badges, as bearing Athlete’s NIL Rights
                      </span>
                    </strong>
                  </p>
                </td>
                <td
                  style={{
                    width: "159.95pt",
                    borderTopStyle: "solid",
                    borderTopWidth: "0.75pt",
                    borderLeftStyle: "solid",
                    borderLeftWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "12pt",
                    }}
                  >
                    <span>Up to 94% of a fan’s contribution</span>
                    <br />
                    <span>88% - Athlete (if no Manager)&nbsp;</span>
                  </p>
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "12pt",
                    }}
                  >
                    <span>
                      79.2% - Athlete (if Manager chosen by Athlete to use){" "}
                    </span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <p
            className="text-justify"
            style={{
              marginLeft: "18pt",
            }}
          >
            <span>“</span>
            <strong>
              <span>Gross Revenue</span>
            </strong>
            <span>
              ” is defined as all revenue received from the sale of a specific
              Product and/or Service bearing Athlete’s NIL Rights.
            </span>
          </p>

          <p
            className="text-justify"
            style={{
              marginLeft: "18pt",
            }}
          >
            <span>
              Regarding Athlete’s participation in FHP Products bearing
              Athlete’s NIL rights, FHP agrees that Athlete shall set Athlete’s
              own price within the limits provided at FHP’s Platform, except
              that Athlete and FHP agree that a purchasing Fan shall set the
              price for Endorsement Badge which bears Athlete’s NIL rights, such
              price calculated at rate of one ($1) dollar per week of allowed
              Fan posting of said Endorsement Badge on Fan’s social media, such
              length at least four (4) weeks as recognized by minimum price of
              four ($4) dollars for said Endorsement Badge, and up to five
              hundred ninety-nive ($599) dollars for an Endorsement Badge price
              selectable by Fan wherein Endorsement Badge bearing Athlete’s NIL
              rights and license allowing Fan up to 599 weeks of social media
              display of said Endorsement Badge on Fan’s social media.
            </span>
          </p>

          <p
            className="text-justify"
            style={{
              marginLeft: "18pt",
            }}
          >
            <span>
              Regarding Athlete’s participation in fans’ pay-per-minute chats
              with Athlete, FHP agrees that Athlete shall set Athlete’s own
              “per-minute” rate <b>(“PM Chat Rate”)</b> within limits set on FHP
              Platform, and FHP agrees to pay Athlete a percentage of Gross
              Earnings (as defined below) earned therefrom, as per fan rating of
              specific chat, as follows:
            </span>
          </p>
          <table
            cellPadding={0}
            cellSpacing={0}
            style={{
              marginLeft: "18pt",
              border: "0.75pt solid #000000",
              borderCollapse: "collapse",
              width: "96%",
            }}
          >
            <tbody>
              <tr style={{ height: "36.4pt" }}>
                <td
                  style={{
                    borderRightStyle: "solid",
                    borderRightWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      textAlign: "justify",
                      fontSize: "12pt",
                    }}
                  >
                    <strong>
                      <span>Pay-Per-Minute Chats</span>
                    </strong>
                  </p>
                </td>
                <td
                  style={{
                    borderLeftStyle: "solid",
                    borderLeftWidth: "0.75pt",
                    paddingRight: "5.03pt",
                    paddingLeft: "5.03pt",
                    verticalAlign: "top",
                  }}
                >
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      fontSize: "12pt",
                    }}
                    className="d-flex justify-content-between"
                  >
                    <span>Satisfactory / No Rating:</span>
                    <span>
                      <p>88% - Athlete if no Manager used&nbsp;</p>
                      <p>79.2% - Athlete if Manager used &nbsp;</p>
                    </span>
                  </p>
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      fontSize: "12pt",
                    }}
                    className="d-flex justify-content-between"
                  >
                    <span>Unsatisfactory Rating (Rude/Short Time):</span>
                    <span>
                      <p>53% - Athlete if no Manager&nbsp;</p>
                      <p>47.7% - Athlete if Manager use&nbsp;</p>
                    </span>
                  </p>
                  <p
                    style={{
                      marginTop: "0pt",
                      marginBottom: "0pt",
                      fontSize: "12pt",
                    }}
                    className="d-flex justify-content-between"
                  >
                    <span>Unsatisfactory Rating (No Show): </span>
                    <span>
                      <p>23% - Athlete if no Manager used&nbsp;</p>
                      <p>20.7% - Athlete if Manager used&nbsp;</p>
                    </span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
          <p
            style={{
              marginTop: "0pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>“</span>
            <strong>
              <span>Gross Earnings</span>
            </strong>
            <span>
              ” is defined as all revenues of any type received from hosting of
              a specific pay-per-minute chat with Athlete wherein athlete’s
              image is shown on screen as per NIL rights grant.
            </span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span>&nbsp;</span>
          </p>
          <p
            style={{
              marginTop: "0pt",
              marginLeft: "18pt",
              marginBottom: "0pt",
              textAlign: "justify",
            }}
          >
            <span className="text-dark" style={{ fontSize: "16px" }}>
              Royalties shall be calculated on a per item sale basis and shall
              be due and payable as accumulated earnings from Athlete wallet on
              demand, provided the accumulated amount exceeds a minimum of
              twenty-five ($25) dollars, or if not, the account continues to
              accumulate until said level is reached, then disbursable.
            </span>
          </p>

          <div className="d-flex justify-content-center align-items-center mt-5 mb-4">
            <Button
              color="success"
              size="lg"
              onClick={() => {
                if (!selectedClause) {
                  toast.error("Please select a contract sharing clause in Part 31 (permitted or not permitted) before accepting.");
                  return;
                }
                setAgreementBox(true);
                toggle();
              }}
              style={{
                padding: "12px 35px",
                fontSize: "18px",
                fontWeight: "bold",
                borderRadius: "50px",
                boxShadow: "0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08)",
              }}
            >
              Agree & Accept Contract Clauses
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default BrandAmbassadorAgreement;
